var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardListArrowTopNoselect = function SvgNewcsDashboardListArrowTopNoselect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 5
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_list_arrow_top_noselect_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M430 439h8v5h-8z",
    "data-name": "\\u77E9\\u5F62 339"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_list_arrow_top_noselect_svg__a)",
    transform: "translate(-430 -439)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "CurrentColor",
    d: "m433.995 439 4 5h-8Z",
    "data-name": 0,
    opacity: 0.6
  }))));
};
export default SvgNewcsDashboardListArrowTopNoselect;